export default "__VITE_ASSET__7mycJGwmtobPiWujWW96Kw__"